@if (debugService.isModifyingState()) {
  <div
    palantirTooltip="O menu de desenvolvedor está ativamente modificando o estado da aplicação."
    class="bg-warning/10 absolute bottom-4 right-4 z-50 flex size-8 items-center justify-center rounded-full border border-solid border-warning-border text-warning shadow-sm"
  >
    &lt;/&gt;
  </div>
}
